export default "/icon-link-external.svg";